import { lazy, Suspense } from "react";

import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import { Loader } from "../components/UI/Loader";
import MainLayout from "../layout/MainLayout";
import AnalyticPage from "../pages/AnalyticPage";
import ChangeSettings from "../pages/ChangeSettings";
import ControlPanel from "../pages/ControlPanel";
import CreatePage from "../pages/CreatePage";
import DemoModelPage from "../pages/DemoModelPage";
import SetupKey from "../pages/SetupKey";
import StorybookPage from "../pages/StorybookPage";
import NotFoundPage from "../pages/404";
import { ProtectedRoute } from "./ProtectedRoute";

const LoginPage = lazy(() => import("../pages/LoginPage"));
const PersonPage = lazy(() => import("../pages/PersonPage"));

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Navigate to="login" />} />

      <Route path="/login" element={<Outlet />}>
        <Route
          index
          element={
            <Suspense fallback={<Loader />}>
              <LoginPage />
            </Suspense>
          }
        />
      </Route>
      <Route
        path="/demo"
        element={
          <ProtectedRoute>
            <Suspense fallback={<Loader />}>
              <MainLayout>
                <DemoModelPage />
              </MainLayout>
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/account"
        element={
          <ProtectedRoute>
            <Suspense fallback={<Loader />}>
              <MainLayout>
                <PersonPage />
              </MainLayout>
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/analytic"
        element={
          <ProtectedRoute>
            <Suspense fallback={<Loader />}>
              <MainLayout>
                <AnalyticPage />
              </MainLayout>
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/analytic_pre_prod"
        element={
          <ProtectedRoute>
            <Suspense fallback={<Loader />}>
              <MainLayout>
                <AnalyticPage />
              </MainLayout>
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/storybook"
        element={
          <ProtectedRoute>
            <Suspense fallback={<Loader />}>
              <MainLayout>
                <StorybookPage />
              </MainLayout>
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route path="/panel/*" element={<Outlet />}>
        <Route
          index
          element={
            <ProtectedRoute>
              <Suspense fallback={<Loader />}>
                <MainLayout>
                  <ControlPanel />
                </MainLayout>
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="create"
          element={
            <ProtectedRoute>
              <Suspense fallback={<Loader />}>
                <MainLayout>
                  <CreatePage />
                </MainLayout>
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path=":id/update"
          element={
            <ProtectedRoute>
              <Suspense fallback={<Loader />}>
                <MainLayout>
                  <ChangeSettings />
                </MainLayout>
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path=":id/setup"
          element={
            <ProtectedRoute>
              <Suspense fallback={<Loader />}>
                <MainLayout>
                  <SetupKey />
                </MainLayout>
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <NotFoundPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <NotFoundPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
